import React from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";

import "./ConfirmModal.css";

export default class ConfirmExitModal extends React.Component { // TODO: rename to ConfirmModal
  render() {
    const {
      headerText,
      bodyText,
      buttonText,
      buttonFunctions,
      disableConfirmButton,
      loadingConfirm,
    } = this.props;

    return (
      <Modal
        open
        maskClosable={false}
        closable={false}
        centered
        footer={null}
        width={388}
        wrapClassName="ConfirmModal"
        className="ConfirmModal"
      >
        <div className="ConfirmModal__root">
          <div className="ConfirmModal__header">
            <h2 className="ConfirmModal__title">{headerText}</h2>
          </div>

          <div className="ConfirmModal__body">
            <p className="ConfirmModal__description">{bodyText}</p>
          </div>

          <div className="ConfirmModal__footer">
            <Button
              type="default"
              onClick={buttonFunctions[0]}
              disabled={disableConfirmButton}
            >
              {buttonText[0]}
            </Button>
            <Button
              type="primary"
              onClick={buttonFunctions[1]}
              disabled={disableConfirmButton}
              loading={loadingConfirm}
            >
              {buttonText[1]}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}
